import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { carImageUrl, PlayerSeasonCar } from '../../service/playerSeasonCar.service';

/**
 * Read-only gallery of every season car a driver has maintained. Shows one
 * card per season with the uploaded image (or a placeholder) and the car name.
 * While `loading` the card stays visible with a placeholder text; a player
 * without any cars gets no card at all.
 */
@Component({
    selector: 'app-player-cars',
    standalone: true,
    templateUrl: './playerCars.component.html',
    styleUrls: ['./playerCars.component.scss'],
    imports: [CommonModule],
})
export class PlayerCarsComponent {
    /** Saved season-car entries, sorted oldest → newest by the API. */
    @Input() seasonCars: PlayerSeasonCar[] = [];
    /** True while the parent is still fetching the entries. */
    @Input() loading = false;

    readonly imageUrl = carImageUrl;
}
